import { render, staticRenderFns } from "./VacationDecline.vue?vue&type=template&id=922dcc74&scoped=true&"
import script from "./VacationDecline.vue?vue&type=script&lang=js&"
export * from "./VacationDecline.vue?vue&type=script&lang=js&"
import style0 from "./VacationDecline.vue?vue&type=style&index=0&id=922dcc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922dcc74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VIcon,VSubheader})
